import { Suspense } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import ActivityLogRouting, {
  routes as activityLogRoutes,
} from 'modules/activityLog/ActivityLog/routing'
import AproLogRouting, {
  routes as aproLogRoutes,
} from 'modules/activityLog/details/AproLogDetails/routing'
import CertificateLogRouting, {
  routes as certificateLogRoutes,
} from 'modules/activityLog/details/CertificateLogDetails/routing'
import CesTestLogRouting, {
  routes as cesTestLogRoutes,
} from 'modules/activityLog/details/CesTestLogDetails/routing'
import CourseLogRouting, {
  routes as courseLogRoutes,
} from 'modules/activityLog/details/CourseLogDetails/routing'
import CstLogRouting, {
  routes as cstLogRoutes,
} from 'modules/activityLog/details/CstLogDetails/routing'
import EducationLogRouting, {
  routes as educationLogRoutes,
} from 'modules/activityLog/details/EducationLogDetails/routing'
import ElearningLogRouting, {
  routes as elearningLogRoutes,
} from 'modules/activityLog/details/ElearningLogDetails/routing'
import OnboardAssessmentLogRouting, {
  routes as onboardAssessmentLogRoutes,
} from 'modules/activityLog/details/OnboardAssessmentLogDetails/routing'
import PproLogRouting, {
  routes as pproLogRoutes,
} from 'modules/activityLog/details/PproLogDetails/routing'
import RapidElearningLogRouting, {
  routes as rapidElearningLogRoutes,
} from 'modules/activityLog/details/RapidElearningLogDetails/routing'
import routes from './routes'

export { routes as activityLogRoutes }

const { RouteChangeProgress } = common

const Routing = () => {
  return (
    <Suspense fallback={<RouteChangeProgress mode={Mode.Light} />}>
      <Switch>
        <Route exact path={activityLogRoutes.root} component={ActivityLogRouting} />
        <Route path={aproLogRoutes.root} component={AproLogRouting} />
        <Route path={certificateLogRoutes.root} component={CertificateLogRouting} />
        <Route path={cesTestLogRoutes.root} component={CesTestLogRouting} />
        <Route path={courseLogRoutes.root} component={CourseLogRouting} />
        <Route path={cstLogRoutes.root} component={CstLogRouting} />
        <Route path={educationLogRoutes.root} component={EducationLogRouting} />
        <Route path={elearningLogRoutes.root} component={ElearningLogRouting} />
        <Route path={onboardAssessmentLogRoutes.root} component={OnboardAssessmentLogRouting} />
        <Route path={pproLogRoutes.root} component={PproLogRouting} />
        <Route path={rapidElearningLogRoutes.root} component={RapidElearningLogRouting} />
        <Redirect path='*' to={routes.root} />
      </Switch>
    </Suspense>
  )
}

export default Routing
